module.exports = __webpack_public_path__ + "img/border-bg.a629dc86.jpg";